<!--
 * @Author: RYL
 * @Description:
 * @Date: 2020-10-28 16:25:25
 * @LastEditTime: 2021-03-08 17:05:22
-->
<template>
  <div>
    <el-form :model="searchData" ref="searchForm" :inline="true" label-width="100px" label-position="right"
      :rules="rules">
      <el-form-item v-if="isAdmin" :label="$t('lang.FastAccess.ownCustomer')" prop="groupId">
        <customer-trees style="vertical-align: top; width: 2rem" ref="customerTrees"
          @getByUser="getByUser"></customer-trees>
      </el-form-item>
      <el-form-item :label="$t('lang.FastAccess.projectName')" prop="groupId">
        <project-trees ref="projectTrees" style="margin-top: 8px; vertical-align: top"
          @clickProject="clickProject"></project-trees>
      </el-form-item>
      <el-form-item :label="$t('lang.alarmNotice.device')" prop="deviceDid">
        <el-select size="mini" @change="deviceChange" v-model="searchData.deviceDid" clearable>
          <el-option v-for="item in deviceList" :key="item.deviceDid" :label="`${item.deviceSn}（${item.deviceName ? item.deviceName : 'N/A'}）`
            " :value="item.deviceDid"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('lang.alarmNotice.terminal')" prop="dtuid">
        <el-select v-model="searchData.dtuid" :placeholder="$t('lang.alarmNotice.terminal')" size="mini"
          style="width: 150px;margin-left: 5px" @change="terminalChange" clearable>
          <el-option v-for="(item, index) in terminalOptions" :key="index" :label="item.name"
            :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('lang.alarmNotice.variable')" prop="vid">
        <el-select v-model="searchData.vid" size="mini" clearable>
          <el-option v-for="item in paramsList" :key="item.id"
            :label="`${item.name}（${item.dtuName ? item.dtuName : 'N/A'}）`" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('lang.onAndOf.time')" prop="dateTime">
        <el-date-picker type="datetimerange" :range-separator="$t('lang.Monitor.to')"
          :start-placeholder="$t('lang.switchCrad.startDate')" :end-placeholder="$t('lang.switchCrad.endDate')"
          v-model="searchData.dateTime" size="mini" :picker-options="pickerOptions"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="mini" type="primary" @click="queryData">{{
          $t("lang.switchCrad.Inquire")
        }}</el-button>
      </el-form-item>
    </el-form>
    <div class="line-chart">
      <line-chart :autoresize="true" :options="lineOptions"></line-chart>
    </div>
    <div class="con">
      <el-pagination @size-change="handleSizeChanges" @current-change="handleCurrentChanges" :current-page="offset"
        :page-sizes="[100, 150, 200, 250]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
        :total="historyTotal"></el-pagination>
    </div>
  </div>
</template>
<script>
import { getFirstGroup, getSecondGroup } from "@/api/cloudMonitor/projectGroup";
import { getListByGroup } from "@/api/cloudMonitor/deviceList";
import { getParamsByDid } from "@/api/cloudMonitor/dashboard";
import { getByDevice } from "@/api/cloudMonitor/terminalList";
import { getParamsByterminal } from "@/api/cloudMonitor/paramsList";
import { getHistoryData } from "@/api/cloudMonitor/historyData";
import projectTrees from "../../components/projectTrees";
import moment from "moment";
import ECharts from "vue-echarts";
import "echarts/lib/chart/line";
import "echarts/lib/component/polar";
import "echarts/lib/component/dataZoom";
import { setData } from "../../../graphs/components/GetValue";
import { unitObj } from "@/utils/paramsConfig";
import customerTrees from "../../components/customerTrees";
import { getPermission } from "@/cookie/cookie";
import { getuser_iscustomer, getuser_ctid } from "@/localStorage/localStorage";
export default {
  components: {
    lineChart: ECharts,
    projectTrees,
    customerTrees,
  },
  data() {
    return {
      searchData: {
        groupId: "",
        deviceDid: "",
        dateTime: [],
        vid: "",
        dtuid: "",
        // vid: [],
      },
      unitObj,
      isAdmin:
        getuser_iscustomer() == 2 ||
          (getuser_ctid() == 0 && getuser_iscustomer() == 1)
          ? true
          : false,
      deviceList: [], // 设备选择列表
      paramsList: [], // 变量选择列表
      terminalOptions: [], // 终端选项
      historyData: [], // 历史数据
      rules: {
        deviceDid: [
          {
            required: true,
            message: this.$t("lang.DateSelect.message2"),
            trigger: ["blur", "change"],
          },
        ],
        dtuid: [
          {
            required: true,
            message: this.$t("lang.Monitor.pleaseTerminal"),
            trigger: ["blur", "change"],
          },
        ],
        vid: [
          {
            required: true,
            message: this.$t("lang.Monitor.pleaseVariable"),
            trigger: ["blur", "change"],
          },
        ],
        dateTime: [
          {
            required: true,
            type: "array",
            message: this.$t("lang.Monitor.Pleasetime"),
            trigger: ["blur", "change"],
          },
        ],
      },
      lineOptions: {}, // 折线图配置
      limit: 100,
      offset: 1,
      historyTotal: 0,
      fistGet: true, // 是否是初始化
      choiceDate: null,
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.choiceDate = minDate.getTime();
          if (maxDate) this.choiceDate = "";
        },
        disabledDate: (time) => {
          if (this.choiceDate) {
            // 7天的时间戳
            const one = 7 * 24 * 3600 * 1000;
            // 当前日期 - one = 7天之前
            const minTime = this.choiceDate - one;
            // 当前日期 + one = 7天之后
            const maxTime = this.choiceDate + one;
            return (
              time.getTime() < minTime ||
              time.getTime() > maxTime ||
              // 限制不能选择今天及以后
              time.getTime() > Date.now()
            );
          } else {
            // 如果没有选择日期，就要限制不能选择今天及以后
            return time.getTime() > Date.now();
          }
        },
      },
    };
  },
  mounted() {
    let time1 = new Date();
    let time2 = new Date().setDate(time1.getDate() - 1); // 取下一天
    this.searchData.dateTime = [new Date(time2), time1];
    if (this.searchData.vid) {
      console.log(this.searchData);
    }
  },
  methods: {
    // 清空数据
    clearData() {
      this.searchData.deviceDid = "";
      this.searchData.vid = "";
      this.searchData.dtuid = "";
      this.deviceList = [];
      this.paramsList = [];
      this.terminalOptions = [];
    },
    // 点击项目节点
    clickProject(node) {
      // 切换了之后，就重置所有数据
      this.clearData();
      let params = {
        pageParam: {
          current: 1,
          size: 99999,
        },
        deviceInfo: {
          deviceGid: node.groupId,
        },
      };
      this.searchData.deviceDid = "";
      this.deviceList = [];
      // 获取设备列表
      getListByGroup(params).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.data;
          this.deviceList = data.records;
          if (this.deviceList.length > 0) {
            this.searchData.deviceDid = this.deviceList[0].deviceDid;
            // 默认获取第一个设备的终端
            this.getDeviceTerminals();
          } else {
            this.fistGet = false;
          }
        }
      });
    },
    // 获取某个设备下的终端列表
    getDeviceTerminals() {
      let params = {
        pageParam: {
          current: 1,
          size: 99999,
        },
        dtuInfo: {
          did: this.searchData.deviceDid,
        },
      };
      getByDevice(params).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.data;
          this.terminalOptions = data.records;
          if (this.terminalOptions.length > 0) {
            this.searchData.dtuid = this.terminalOptions[0].id;
            // 获取变量
            this.getTermianlParams();
          } else {
            this.fistGet = false;
          }
        }
      });
    },
    // 获取某个终端的变量
    getTermianlParams() {
      if (this.searchData.dtuid) {
        getParamsByterminal(this.searchData.dtuid).then((res) => {
          if (res.data.code === 0) {
            this.paramsList = res.data.data;
            if (this.paramsList.length > 0) {
              this.searchData.vid = this.paramsList[0].id;
            }
            if (this.fistGet) {
              this.getData();
            }
            this.fistGet = false;
          }
        });
      }
    },
    // 查询数据
    queryData() {
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          this.getData();
        } else {
          return false;
        }
      });
    },
    // 历史数据
    getData() {
      if (this.searchData.vid) {
        let params = {
          current: this.offset,
          size: this.limit,
          dtuid: this.searchData.dtuid,
          did: this.searchData.deviceDid,
          vid: this.searchData.vid,
          sts: moment(this.searchData.dateTime[0]).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          ets: moment(this.searchData.dateTime[1]).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
        };
        getHistoryData(params).then((res) => {
          if (res.data.code === 0) {
            this.historyData = res.data.data.records;
            this.historyTotal = res.data.data.total;
            this.initLineChart();
          }
        });
      }
    },
    // 初始化折线图
    initLineChart() {
      let vname = this.historyData.length > 0 ? this.historyData[0].vname : "";
      let xData = [];
      let yData = [];
      let unit =
        this.historyData.length > 0
          ? `${this.$t('lang.variableList.unit')}（${this.unitObj[this.historyData[0].unit]}）`
          : "";
      this.historyData.forEach((element) => {
        xData.push(moment(new Date(element.ts)).format("HH:mm:ss MM-DD "));
        yData.push(element.strVal);
      });
      console.log(this.historyData[0]);
      this.lineOptions = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            animation: false,
          },
        },
        legend: {
          data: [vname],
        },
        dataZoom: [
          {
            show: true,
            realtime: true,
            start: 0,
            end: 20,
          },
        ],
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: xData.map((str) => {
            return str.replace(" ", "\n");
          }),
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true,
        },
        yAxis: {
          type: "value",
          name: unit,
        },
        series: [
          {
            name: vname,
            type: "line",
            data: yData,
          },
        ],
      };
    },
    // 项目分组根据用户Id查询
    getByUser(userId) {
      this.$refs.projectTrees.getByUser(userId);
    },
    // 设备选择发生变化, 重新获取终端和变量
    deviceChange(val) {
      this.getDeviceTerminals();
    },
    // 终端发生变化
    terminalChange(val) {
      this.getTermianlParams();
    },
    handleSizeChanges(val) {
      this.limit = val;
      this.getData();
    },
    handleCurrentChanges(val) {
      this.offset = val;
      this.getData();
    },
  },
};
</script>
<style scoped>
.line-chart {
  width: 100%;
  height: 70vh;
}

.echarts {
  width: 100%;
  height: 100%;
  margin-top: 20px;
}

.con {
  text-align: center;
  margin-top: 0.4rem;
}

/* .el-select-dropdown__item{
  padding-right: 30px;
} */
</style>
